import type { SceneDesc } from '@seddi/ui-three-viewer';

import type { Quaternion } from '../core/mathTypes';

interface Camera {
  quaternion: Quaternion;
}

/**
 * Compute environment rotation that keeps the rotation around the Y axis in sync with the camera view.
 * @param camera - Camera.
 */
export function computeRotationFromCamera(camera: Camera): number {
  const { quaternion } = camera;
  // Project quaternion onto the Y axis by discarding x/z, then extract the angle.
  // For q = (0, y, 0, w) normalized: angle = 2 * atan2(y, w). The normalization
  // factor sqrt(y²+w²) cancels, so we can use the raw components directly.
  return 2 * Math.atan2(quaternion.y, quaternion.w);
}

export function getEnvironmentRotation(scene: SceneDesc) {
  const entity = scene.children.find(e => e.components.environment)!;
  const environmentComponent = entity.components.environment!;
  const { environment } = environmentComponent;
  const environmentRotation = environmentComponent.rotation ?? environment.rotation ?? 0;
  return environmentRotation;
}
